<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="Message">{{Message}}</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Global } from '@/Service/GlobalService'
import { swal } from '@/Service/SweetAlert2'
import { LINENotify } from '@/mixins/LINENotify'

import { LINEPayConfirm } from '@/Service/APIService'

export default {
  name: "LINEPayConfirm",
  mixins: [ LINENotify ],
  data() {
    return {
      Message: "金流手續確認中...", // 訊息
    }
  },
  methods: {
    init: async function() {
      if (!this.$cookies.get("Order")) this.$router.push({ name: `Home` })
      this.waitAnimation()
      let Order = this.$cookies.get("Order")
      let transactionId = location.href.split("=")[1]
      transactionId = transactionId.split("&")[0]

      const params = {
        id: Order.id,
        shopId: Order.shopId,
        transactionId: transactionId,
        Price: Order.Price
      }
      
      const response = await LINEPayConfirm(params)

      this.$data.Confirm = response.data

      const returnCode = this.$data.Confirm.returnCode

      if (returnCode == "0000") {
        this.$data.Message = "付款完成，訂單傳送中"
        this.$cookies.remove("Order")
        swal.alertSuccess(Global.MESSAGE.LINEPAY.PAYMENT_SUCCESS)
        if (!Global.User) {
          this.$router.push({ name: `Orders` })
          return false
        }
        this.$router.push({ name: `Orders` })
        // if (!this.checkInitialLineNotifyUsage()) this.$router.push({ name: `Orders` })
      } else {
        this.$data.Message = "交易失敗！"
        swal.alertError(Global.MESSAGE.LINEPAY.PAYMENT_FAILED)
        setTimeout(() => { this.$router.push({ name: 'Cart' }) }, 1000)
      }
    },
    /* 付款完成，訂單傳送中，的文字輪播 */
    waitAnimation: function() {
      switch (this.$data.Message) {
        case "付款完成，訂單傳送中":
          this.$data.Message = "付款完成，訂單傳送中."
          break
        case "付款完成，訂單傳送中.":
          this.$data.Message = "付款完成，訂單傳送中.."
          break
        case "付款完成，訂單傳送中..":
          this.$data.Message = "付款完成，訂單傳送中..."
          break
        case "付款完成，訂單傳送中...":
          this.$data.Message = "付款完成，訂單傳送中"
          break
      }
      setTimeout(() => { if (this.$route.name == "LINEPayConfirm") this.waitAnimation() }, 250)
    },
    checkInitialLineNotifyUsage: function() {

      if (localStorage.getItem("lineNotifyUsageChecked") != null) return false

      return confirm("是否啟用 LINE Notify 通知取餐？") ? this.setLINENotify({ redirectToPage: "Orders" }) : localStorage.setItem("lineNotifyUsageChecked", false)
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.container-fluid {
  > .row {
    > .col {
      margin-top: 50vh;
      > .Message {
        text-align: center;
        font-size: 24px;
        font-weight: bold;
      }
    }
  }
}
</style>